import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { type Pipeline, PIPELINES } from './osintConstantineConstants';

interface PipelineSelectProps {
  value: Pipeline;
  onValueChange: (value: Pipeline) => void;
  disabled?: boolean;
}

export function PipelineSelect({
  value,
  onValueChange,
  disabled,
}: PipelineSelectProps) {
  return (
    <div>
      <span className="text-chariot-text-primary mb-1 block text-sm font-medium">
        Run Tier
      </span>
      <Select
        value={value}
        onValueChange={val => onValueChange(val as Pipeline)}
        disabled={disabled}
      >
        <SelectTrigger aria-label="Run Tier">
          <SelectValue placeholder="Select pipeline..." />
        </SelectTrigger>
        <SelectContent>
          {PIPELINES.map(p => (
            <SelectItem key={p} value={p}>
              {p.charAt(0).toUpperCase() + p.slice(1)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-chariot-text-secondary mt-1 text-xs">
        Premium runs the deepest analysis; Basic is fastest and cheapest.
      </p>
    </div>
  );
}
